// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2XnxN","footer":"ModalError_footer__3seXT"};